<template>
  <el-form-item :label="organName" :prop="selectProp">
    <el-select
      v-model="value"
      :multiple="multiple"
      :collapse-tags="collapseTags"
      @change="handleChange"
      :disabled="organDisabled"
      filterable
      :style="'width: ' + selectWidth"
    >
      <el-option
        v-for="item in listLevelName"
        :key="item.id"
        :label="item.levelName"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import OrganService from "service/OrganService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import StorageService from "store/interfaces";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "select-level",
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  data() {
    return {
      value: this.selectValue,
      listLevelName: [],
    };
  },
  props: {
    selectValue: "",
    selectProp: {
      type: String,
      default: "tatSimpleId",
    },
    organName: {
      type: String,
      default: "等级名称",
    },
    selectWidth: {
      type: String,
      default: "auto",
    },
    needAll: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    collapseTags: {
      type: Boolean,
      default: false,
    },
    organDisabled: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  mounted() {
    this.loadList();
  },
  activated() {
    this.loadList();
  },
  watch: {
    selectValue(val) {
      // console.log(val)
      this.value = val;
    },
  },
  computed: {
    // ...mapGetters(["tatSimpleNames", "reloadTatNameList"]),
  },
  methods: {
    loadList() {
      this.getSimpleNames();
      // if (!this.reloadTatNameList && this.tatSimpleNames.length) {
      //   this.getListLevelName(this.tatSimpleNames);
      // } else {
      //   this.getSimpleNames();
      // }
    },
    getSimpleNames() {
      this.doLoad(
        OrganService.memberupgradeList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.getListLevelName(res.contents.rows);
            // this.setTatName(res.contents);
            // this.reloadTat(false);
          });
        },
        "信息获取失败"
      );
    },
    getListLevelName(data) {
      this.listLevelName = this.needAll
        ? [
            ...[
              {
                id: "",
                levelName: "全部",
              },
            ],
            ...data,
          ]
        : data;
    },
    handleChange(val) {
      this.$emit("change", val);
    },
    // ...mapActions({
    //   setTatName: StorageService.Page.tatName,
    //   reloadTat: StorageService.Reload.tatNameList,
    // }),
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/business/SelectLevel.vue